const ProtectedComponent = ({ permission, userPermissions, children }) => {
    return userPermissions.includes(permission) ? <>{children}</> : null;
  };

export default ProtectedComponent


